import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import Routes from "routing/Routes";
const MessagePermalinkButton = ({ messageIndex, messageId }) => {
  const { t } = useTranslation("search");
  const messageUrl = messageIndex ? Routes.message_show(messageIndex, messageId) : "#";
  return /* @__PURE__ */ React.createElement(Button, { href: messageUrl, disabled: !messageIndex, bsSize: "small" }, t("message_permalink.label"));
};
export default MessagePermalinkButton;
